var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"footer__iframe",attrs:{"id":"dn-footer-iframe","src":_vm.standaloneFooterUrl,"width":"100%","seamless":"seamless","frameborder":"0","scrolling":"no","height":"553px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }